<template>
  <FieldArray v-slot="{ fields, remove, push }" name="allowedValues">
    <vl-grid v-vl-spacer:top.medium>
      <vl-column width="8" width-xs="12">
        <vl-title tag-name="h4"> {{ $t('entityAttribute.detail.allowedValues') }} </vl-title>
      </vl-column>
      <vl-column width="4" width-xs="12">
        <vl-action-group mod-align-right>
          <vl-button type="button" icon="add" mod-icon @click="push('')"></vl-button>
        </vl-action-group>
      </vl-column>
    </vl-grid>
    <vl-grid v-if="fields.length">
      <vl-column width="12" width-xs="12">
        <vl-form-message-label> {{ $t('entityAttribute.detail.domainValue') }} </vl-form-message-label>
      </vl-column>
      <vl-column width="1" width-xs="4"> </vl-column>
      <vl-column width="12" width-xs="12">
        <hr />
      </vl-column>
    </vl-grid>
    <vl-grid v-for="(field, idx) in fields" :key="field.key">
      <vl-column width="6" width-xs="4">
        <template v-if="isDateTimeOrDateOnlyField">
          <Field v-slot="{ errors, value, handleChange }" :name="`allowedValues[${idx}]`">
            <PbsDatepicker
              id="dateValue"
              name="dateValue"
              required
              :mod-error="!!errors.length"
              :mod-required="true"
              :value="value"
              :enable-time="isDateTimeField"
              :no-calendar="isDateTimeField"
              :visualFormat="dateFormat"
              :format="dateFormat"
              @input="onDatepickerInput(handleChange)($event)"
            >
              >
            </PbsDatepicker>
            <vl-form-message-error v-if="errors">{{ errors[0] }}</vl-form-message-error>
          </Field>
        </template>
        <template v-else>
          <PbsInputField
            required
            :name="`allowedValues[${idx}]`"
            :placeholder="t('entityAttribute.detail.domainValuePlaceholder')"
          />
        </template>
      </vl-column>
      <vl-column width="1" width-xs="4">
        <vl-action-group>
          <vl-button type="button" icon="trash" mod-icon mod-error @click="remove(idx)"></vl-button>
        </vl-action-group>
      </vl-column>
    </vl-grid>
    <vl-grid v-if="!fields.length">
      <vl-column width="12" width-xs="12">
        {{ $t('entityAttribute.detail.noAllowedValues') }}
      </vl-column>
    </vl-grid>
    <PbsErrorField name="allowedValues" />
  </FieldArray>
</template>
<script lang="ts" setup>
import { computed, onMounted } from 'vue';
import { Field, FieldArray } from 'vee-validate';
import PbsErrorField from '@/components/forms/PbsErrorField.vue';
import PbsInputField from '@/components/forms/PbsInputField.vue';
import PbsDatepicker from '@/components/forms/PbsDatepicker.vue';
import { useI18n } from 'vue-i18n';
import { EnumerationDto } from '@/api/backoffice/clients';

const { t } = useI18n();

const props = defineProps<{
  dataType?: EnumerationDto | undefined;
}>();

const isDateOnlyField = computed((): boolean => {
  return props.dataType && ['Datum'].some((x) => x === props.dataType.name);
});

const isDateTimeField = computed((): boolean => {
  return props.dataType && ['Datum + tijd'].some((x) => x === props.dataType.name);
});

const isDateTimeOrDateOnlyField = computed((): boolean => {
  return isDateOnlyField.value || isDateTimeField.value;
});

const dateFormat = computed((): string => {
  return isDateOnlyField.value ? 'd-m-Y' : 'd-m-Y H:i';
});

const onDatepickerInput = (handleChange) => (value) => {
  let isoString = '';
  const dateValue = Array.isArray(value) ? value[0] : value;
  if (dateValue instanceof Date) {
    isoString = dateValue.toISOString();
  }
  handleChange(isoString);
};

onMounted(async () => {});
</script>
<style lang="scss" scoped></style>
